import cn from 'classnames';
import { EngineTheme } from '@websky/core/src/theme';
import Shared from './components/Shared';
import themeShared from './themeShared';

import Airplane from './components/SeatMap/Airplane/Airplane.css';
import Passenger from './components/SeatMap/Passenger/Passenger.css';
import SeatMapPassengers from './components/SeatMap/Passengers/Passengers.css';
import SeatMap from './components/SeatMap/SeatMap.css';
import SeatsInfo from './components/SeatMap/SeatsInfo/SeatsInfo.css';
import SearchForm from './components/SearchForm/SearchForm.css';
import SearchFormSegments from './components/SearchForm/Segments/Segments.css';
import SearchFormSegment from './components/SearchForm/Segment/Segment.css';
import SearchFormControls from './components/SearchForm/Controls/Controls.css';
import SearchFormMultiCity from './components/SearchForm/MultiCity/MultiCity.css';
import SearchFormPassengers from './components/SearchForm/Passengers/Passengers.css';
import SearchFormCurrency from './components/SearchForm/Currency/Currency.css';
import SearchFormStartSearch from './components/SearchForm/StartSearch/StartSearch.css';
import SearchFormDatepicker from './components/SearchForm/Datepicker/Datepicker.css';
import SearchFormLocation from './components/SearchForm/Location/Location.css';
import SearchFormBottom from './components/SearchForm/Bottom/Bottom.css';
import SearchFormActions from './components/SearchForm/Actions/Actions.css';
import SearchFormValue from './components/SearchForm/Value/Value.css';
import SearchFormDatepickerStyles from './components/SearchFormDatepicker/SearchFormDatepicker.css';
import SearchFormDatepickerMonthHeader from './components/SearchFormDatepicker/MonthHeader/MonthHeader.css';
import SearchFormDatepickerWeeklyHeader from './components/SearchFormDatepicker/WeeklyHeader/WeeklyHeader.css';
import SearchFormDatepickerDay from './components/SearchFormDatepicker/Day/Day.css';
import SearchFormDatePickerMonthsWrapper from './components/SearchFormDatepicker/MonthsWrapper/MonthsWrapper.css';
import DirectionsDialog from './components/LocationAutocomplete/DirectionsDialog/DirectionsDialog.css';
import Passengers from './components/Passengers/Passengers.css';
import Stepbar from './components/Stepbar/Stepbar.css';
import StepbarStep from './components/Stepbar/Step/Step.css';
import QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import QuickSearchFormSummary from './components/QuickSearchForm/Summary/Summary.css';
import Results from './components/Results/Results.css';
import ResultsCalendar from './components/Results/Calendar/Calendar.css';
import ResultsSortings from './components/Results/Sortings/Sortings.css';
import ResultsFlightsList from './components/Results/FlightsList/FlightsList.css';
import ResultsSelectedFares from './components/Results/SelectedFares/SelectedFares.css';
import ResendTicketsForm from './components/ResendTicketsForm/ResendTicketsForm.css';
import DesktopFlightRoute from './components/DesktopFlightRoute/DesktopFlightRoute.css';
import DesktopFlightRoutePrice from './components/DesktopFlightRoute/FlightPrice/FlightPrice.css';
import DesktopFlightRoutePoint from './components/DesktopFlightRoute/Point/Point.css';
import DesktopFlightRouteArrow from './components/DesktopFlightRoute/RouteArrow/RouteArrow.css';
import DesktopFlightRouteSegment from './components/DesktopFlightRoute/Segment/Segment.css';
import DesktopFlightRouteStopsInfo from './components/DesktopFlightRoute/StopsInfo/StopsInfo.css';
import DesktopFlightModalContent from './components/DesktopFlight/ModalContent/ModalContent.css';
import DesktopFlightInfoSegment from './components/DesktopFlight/FlightInfoSegment/FlightInfoSegment.css';
import DesktopFlightLocation from './components/DesktopFlight/Location/Location.css';
import DesktopFlightModalHeader from './components/DesktopFlight/DesktopFlightModalHeader/DesktopFlightModalHeader.css';
import DesktopFlightSelectedFareGroup from './components/DesktopFlight/SelectedFareGroup/SelectedFareGroup.css';
import DesktopFlightPopup from './components/DesktopFlight/DesktopFlightPopup/DesktopFlightPopup.css';
import FlightCard from './components/FlightCard/FlightCard.css';
import CompareFares from './components/CompareFares/CompareFares.css';
import TransferInfo from './components/TransferInfo/TransferInfo.css';
import FareLock from './components/FareLock/FareLock.css';
import Toolbar from './components/Toolbar/Toolbar.css';
import MobileSegmentInfo from './components/MobileSegmentInfo/MobileSegmentInfo.css';
import MobileFlight from './components/MobileFlight/MobileFlight.css';
import Baggage from './components/Baggage/Baggage.css';
import UpgradeBaggageDialog from './components/UpgradeBaggageDialog/UpgradeBaggageDialog.css';
import Meal from './components/Meal/Meal.css';
import PassengerCounter from './components/widgets/PassengerCounter/PassengerCounter.css';
import Modal from './components/widgets/Modal/Modal.css';
import DesktopSummaryFlight from './components/DesktopSummaryFlight/DesktopSummaryFlight.css';
import Contacts from './components/Contacts/Contacts.css';
import Checkout from './components/Checkout/Checkout.css';
import CheckoutPassengers from './components/Checkout/Passengers/Passengers.css';
import CheckoutPassengersToolbar from './components/Checkout/PassengersToolbar/PassengersToolbar.css';
import CheckoutThanksBanner from './components/Checkout/ThanksBanner/ThanksBanner.css';
import PassengerForm from './components/PassengerForm/PassengerForm.css';
import PassengerFormHeader from './components/PassengerForm/Header/Header.css';
import PassengerFormGroup from './components/PassengerForm/Group/Group.css';
import PassengerSwitch from './components/Passenger/Switch/Switch.css';
import Input from './components/Input/Input.css';
import OrderCard from './components/OrderCard/OrderCard.css';
import OrderPreview from './components/OrderCard/OrderPreview/OrderPreview.css';
import OrderBooking from './components/OrderCard/OrderBooking/OrderBooking.css';
import OrderCommonItem from './components/OrderCard/CommonItem/CommonItem.css';
import OrderCardControls from './components/OrderCard/OrderCardControls/OrderCardControls.css';
import AdditionalServiceWrapper from './components/AdditionalServiceWrapper/AdditionalServiceWrapper.css';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import Autocomplete from './components/Autocomplete/Autocomplete.css';
import CartToolbar from './components/Cart/Toolbar/Toolbar.css';
import ServiceSummary from './components/ServiceSummary/ServiceSummary.css';
import ServiceSummaryOption from './components/ServiceSummary/ServiceSummaryOption/ServiceSummaryOption.css';
import InsurancePopup from './components/InsurancePopup/InsurancePopup.css';
import DeleteOrderModal from './components/OrderCard/DeleteOrderModal/DeleteOrderModal.css';
import AddBooking from './components/AddBooking/AddBooking.css';
import WxPagination from './components/WxPagination/WxPagination.css';
import FfpInfo from './components/LoyaltyInfo/FfpInfo/FfpInfo.css';
import LoyaltyInfo from './components/LoyaltyInfo/LoyaltyInfo.css';
import LoyaltyInfoCard from './components/LoyaltyInfo/Card/Card.css';
import MilesHistory from './components/MilesHistory/MilesHistory.css';
import Traveller from './components/Traveller/Traveller.css';
import AccountModule from './components/AccountModule/AccountModule.css';
import CheckinInital from './components/Checkin/Inital/Inital.css';
import Checkin from './components/Modules/Checkin/components/Checkin/Checkin.css';
import CheckinPassengers from './components/Checkin/Passengers/Passengers.css';
import RegisteredPassenger from './components/RegisteredPassenger/RegisteredPassenger.css';
import Service from './components/RegisteredPassenger/Service/Service.css';
import RetrieveBooking from './components/RetrieveBooking/RetrieveBooking.css';
import SelectedPassenger from './components/SelectedPassenger/SelectedPassenger.css';
import StatusMessage from './components/StatusMessage/StatusMessage.css';
import SegmentCommon from './components/Segment/SegmentCommon/SegmentCommon.css';
import MobileSegment from './components/MobileSegment/MobileSegment.css';
import MealService from './components/MealService/MealService.css';
import Exchange from './components/Exchange/Exchange.css';
import Refund from './components/Refund/Refund.css';
import ModalConfirm from './components/ModalConfirm/ModalConfirm.css';
import CheckDataModal from './components/CheckDataModal/CheckDataModal.css';
import ModalX from './components/ModalX/ModalX.css';
import PromoLoader from './components/PromoLoader/PromoLoader.css';
import Notification from './components/Notification/Notification.css';
import VipServiceSelect from './components/VipServiceSelect/VipServiceSelect.css';
import DocumentForm from './components/DocumentForm/DocumentForm.css';
import Loyalty from './components/Loyalty/Loyalty.css';
import Transfer from './components/TransferService/TransferService.css';
import CheckinRules from './components/CheckinRules/CheckinRules.css';
import InsurancePage from './components/InsurancePage/InsurancePage.css';
import Fare from './components/Entities/Fare.css';

const theme: EngineTheme = {
	...themeShared,
	SearchForm: {
		SearchForm: {
			searchForm: cn(SearchForm.searchForm, QuickSearchForm.searchForm),
			beforeAdornment__wrapper: SearchForm.beforeAdornment__wrapper
		},
		Segments: {
			segments: SearchFormSegments.segments,
			segments_multiCity: cn(SearchFormSegments.segments_multiCity, SearchFormSegment.segments_multiCity)
		},
		Segment: {
			wrapper: SearchFormSegment.wrapper,
			segment: SearchFormSegment.segment,
			withMultiCity: SearchFormSegment.withMultiCity,
			cell: SearchFormSegment.cell,
			cell_date: SearchFormSegment.cell_date,
			cell_location: SearchFormSegment.cell_location,
			input: SearchFormSegment.input,
			input_text: SearchFormSegment.input_text,
			input_focused: SearchFormSegment.input_focused,
			datepicker_value: SearchFormSegment.datepicker_value,
			alternative: SearchFormSegment.alternative,
			location__value: SearchFormSegment.location__value
		},
		Controls: {
			controls: SearchFormControls.controls,
			controls_multiCity: cn(SearchFormControls.controls_multiCity, SearchFormCurrency.controls_multiCity)
		},
		MultiCity: {
			multiCity: SearchFormMultiCity.multiCity,
			caption: SearchFormMultiCity.caption
		},
		Passengers: {
			passengers: SearchFormPassengers.passengers,
			passengers_isMultiCity: SearchFormPassengers.passengers_isMultiCity,
			menu: SearchFormPassengers.menu,
			selector: SearchFormPassengers.selector,
			title: SearchFormPassengers.title,
			alternative: SearchFormPassengers.alternative,
			mobileTitle: SearchFormPassengers.mobileTitle
		},
		Currency: {
			currency: SearchFormCurrency.currency,
			selector: SearchFormCurrency.selector,
			arrowIcon: SearchFormCurrency.arrowIcon,
			item: SearchFormCurrency.item,
			dropdown: SearchFormCurrency.dropdown
		},
		StartSearch: {
			startSearch: SearchFormStartSearch.startSearch,
			startSearch_iconMode: SearchFormStartSearch.startSearch_iconMode,
			startSearch_multiCity: SearchFormStartSearch.startSearch_multiCity
		},
		Datepicker: {
			dates: SearchFormDatepicker.dates,
			dates_focused: SearchFormDatepicker.dates_focused,
			dates__to: SearchFormDatepicker.dates__to,
			dates__back: SearchFormDatepicker.dates__back,
			dates__to_focused: SearchFormDatepicker.dates__to_focused,
			dates__back_focused: SearchFormDatepicker.dates__back_focused,
			dates__to_text: SearchFormDatepicker.dates__to_text,
			placeholder: SearchFormDatepicker.placeholder,
			date__inputWrapper: SearchFormDatepicker.date__inputWrapper,
			dow: SearchFormDatepicker.dow,
			highlighted_minPrice: SearchFormDatepicker.highlighted_minPrice,
			alternative: SearchFormDatepicker.alternative,
			alternative_dow: SearchFormDatepicker.alternative_dow,
			dates__icon: SearchFormDatepicker.dates__icon
		},
		Location: {
			switcher: SearchFormLocation.switcher,
			switcher_alternative: SearchFormLocation.switcher_alternative
		},
		Bottom: {
			controls: SearchFormBottom.controls
		},
		Actions: {
			actions: SearchFormActions.actions,
			addSegment: SearchFormActions.addSegment,
			removeSegment: SearchFormActions.removeSegment
		},
		Value: {
			wrapper_alternative: SearchFormValue.wrapper_alternative,
			value: SearchFormValue.value,
			code: SearchFormValue.code
		},
		PayByMiles: {
			switchWrapper: SearchForm.payByMiles__switchWrapper
		}
	},
	SearchFormDatepicker: {
		SearchFormDatepickerStyles: {
			popup: SearchFormDatepickerStyles.popup,
			dialog__bar: SearchFormDatepickerStyles.dialog__bar,
			dialog__dates: SearchFormDatepickerStyles.dialog__dates,
			dialog__activeDate: SearchFormDatepickerStyles.dialog__activeDate,
			dialog__dateBack: SearchFormDatepickerStyles.dialog__dateBack,
			dialog__close: SearchFormDatepickerStyles.dialog__close,
			footer: SearchFormDatepickerStyles.footer,
			footer__buttons: SearchFormDatepickerStyles.footer__buttons,
			footer__clear: SearchFormDatepickerStyles.footer__clear,
			footer__done: SearchFormDatepickerStyles.footer__done,
			tab__wrapper: SearchFormDatepickerStyles.tab__wrapper,
			tab: SearchFormDatepickerStyles.tab,
			tab_selected: SearchFormDatepickerStyles.tab_selected,
			datepicker__disclaimer: SearchFormDatepickerStyles.datepicker__disclaimer,
			content: SearchFormDatepickerStyles.content
		},
		MonthHeaderStyles: {
			monthHeader: SearchFormDatepickerMonthHeader.monthHeader,
			monthHeader__select_month: SearchFormDatepickerMonthHeader.monthHeader__select_month,
			monthHeader__select_year: SearchFormDatepickerMonthHeader.monthHeader__select_year
		},
		WeeklyHeaderStyles: {
			dayOfWeekName: SearchFormDatepickerWeeklyHeader.dayOfWeekName,
			dayOfWeekName_withPrices: SearchFormDatepickerWeeklyHeader.dayOfWeekName_withPrices
		},
		DayStyles: {
			day_withPrice: SearchFormDatepickerDay.day_withPrice,
			day_selected: SearchFormDatepickerDay.day_selected,
			day__price: SearchFormDatepickerDay.day__price,
			day_today: SearchFormDatepickerDay.day_today,
			day_inPeriod: SearchFormDatepickerDay.day_inPeriod,
			day_hasPrice: SearchFormDatepickerDay.day_hasPrice,
			day_weekend: SearchFormDatepickerDay.day_weekend,
			day_startHover_withprice: SearchFormDatepickerDay.day_startHover_withprice,
			day_startHover_withPrice: SearchFormDatepickerDay.day_startHover_withPrice,
			day_endHover_withPrice: SearchFormDatepickerDay.day_endHover_withPrice,
			day_highlighted: SearchFormDatepickerDay.day_highlighted,
			day: SearchFormDatepickerDay.day,
			day__inside: SearchFormDatepickerDay.day__inside,
			day_startPeriod: SearchFormDatepickerDay.day_startPeriod,
			day_endPeriod: SearchFormDatepickerDay.day_endPeriod
		},
		MonthsWrapperStyles: {
			wrapper: SearchFormDatePickerMonthsWrapper.wrapper,
			monthsList: cn(SearchFormDatePickerMonthsWrapper.monthsList, Exchange.monthsList),
			monthsList_withPrice: SearchFormDatePickerMonthsWrapper.monthsList_withPrice,
			nav_next: SearchFormDatePickerMonthsWrapper.nav_next,
			nav_prev: SearchFormDatePickerMonthsWrapper.nav_prev
		},
		MonthStyles: {
			week: SearchFormDatePickerMonthsWrapper.week
		}
	},
	QuickSearchForm: {
		QuickSearchForm: {
			form: cn(QuickSearchForm.form, SearchFormStartSearch.quickSearch__form),
			form__wrapper: QuickSearchForm.form__wrapper
		},
		Summary: {
			route: QuickSearchFormSummary.route,
			passengers: QuickSearchFormSummary.passengers
		}
	},
	Stepbar: {
		Stepbar: {
			cart: Stepbar.cart,
			stepbar: Stepbar.stepbar
		},
		Step: {
			step: StepbarStep.step,
			step_passed: StepbarStep.step_passed
		}
	},
	LocationAutocomplete: {
		DirectionsDialog: {
			dialog: DirectionsDialog.dialog,
			cities: DirectionsDialog.cities,
			label: DirectionsDialog.label,
			countries: DirectionsDialog.countries,
			countries__list: DirectionsDialog.countries__list,
			country: DirectionsDialog.country,
			country_active: DirectionsDialog.country_active,
			city: DirectionsDialog.city,
			iata: DirectionsDialog.iata
		}
	},
	Passengers: {
		PassengerStyles: {
			decrease: Passengers.decrease,
			increase: Passengers.increase
		}
	},
	Inner: {
		Inner: {
			inner: Results.inner__inner
		}
	},
	Notification: {
		Notification: {
			context: Notification.context,
			info: Notification.info,
			icon: Notification.icon
		}
	},
	Results: {
		Results: {
			results: Results.results,
			header: Results.header,
			header__stepbar: Results.header__stepbar,
			inner: Results.inner,
			toolbar__backButton: Results.toolbar__backButton,
			share: Results.share,
			outer_bottom: Results.outer_bottom
		},
		Calendar: {
			header: ResultsCalendar.header,
			legNumber: ResultsCalendar.legNumber,
			title__text: ResultsCalendar.title__text,
			title__cities: ResultsCalendar.title__cities,
			diagram: ResultsCalendar.diagram
		},
		Sortings: {
			title: ResultsSortings.title,
			sortBy: ResultsSortings.sortBy,
			currentSorting: ResultsSortings.currentSorting,
			flightType: ResultsSortings.flightType,
			flightType__active: ResultsSortings.flightType__active,
			listItem: ResultsSortings.listItem,
			listItem_active: ResultsSortings.listItem_active,
			paper: ResultsSortings.paper,
			mobile__list: ResultsSortings.mobile__list,
			mobile__list__title: ResultsSortings.mobile__list__title,
			mobile__list__close: ResultsSortings.mobile__list__close,
			mobile__list__item: ResultsSortings.mobile__list__item,
			mobile__list__button: ResultsSortings.mobile__list__button,
			mobile__list__button_inactive: ResultsSortings.mobile__list__button_inactive,
			mobile__closeButton: ResultsSortings.mobile__closeButton
		},
		FlightsList: {
			wrapper: ResultsFlightsList.wrapper,
			controls__wrapper: ResultsFlightsList.controls__wrapper,
			leg: ResultsFlightsList.leg
		},
		SelectedFares: {
			title: ResultsSelectedFares.title
		}
	},
	DesktopFlightRoute: {
		DesktopFlightRouteStyles: {
			flight: DesktopFlightRoute.flight
		},
		SegmentStyles: {
			flightInfo__date: DesktopFlightRouteSegment.flightInfo__date,
			flightInfo__airline: DesktopFlightRouteSegment.flightInfo__airline,
			aircraft: DesktopFlightRouteSegment.aircraft,
			segment: DesktopFlightRouteSegment.segment,
			segment_additional: DesktopFlightRouteSegment.segment_additional,
			totalDuration__decorator: DesktopFlightRouteSegment.totalDuration__decorator,
			flightInfo__nextDay: DesktopFlightRouteSegment.flightInfo__nextDay,
			planeInfo: DesktopFlightRouteSegment.planeInfo
		},
		PointStyles: {
			time: DesktopFlightRoutePoint.time,
			airport: DesktopFlightRoutePoint.airport,
			point_thin: DesktopFlightRoutePoint.point_thin,
			point: DesktopFlightRoutePoint.point,
			date__container: DesktopFlightRoutePoint.date__container
		},
		RouteArrowStyles: {
			timeInRoute: DesktopFlightRouteArrow.timeInRoute,
			flightNumber: DesktopFlightRouteArrow.flightNumber
		},
		FlightPriceStyles: {
			price: DesktopFlightRoutePrice.price,
			button: DesktopFlightRoutePrice.button,
			selectFrom_best: DesktopFlightRoutePrice.selectFrom_best,
			seats: DesktopFlightRoutePrice.seats
			// taxes: DesktopFlightRoutePrice.taxes
		},
		StopsInfoStyles: {
			stop: DesktopFlightRouteStopsInfo.stop
		}
	},
	DesktopFlight: {
		ModalContent: {
			buttons: DesktopFlightModalContent.buttons,
			fareGroup__button: DesktopFlightModalContent.fareGroup__button,
			fareGroup__button_active: DesktopFlightModalContent.fareGroup__button_active,
			fareGroup__button_business: DesktopFlightModalContent.fareGroup__button_business,
			total_time: cn(TransferInfo.transfer, TransferInfo.transfer__layover),
			compareFaresLink: DesktopFlightModalContent.compareFaresLink,
			slider__wrp: DesktopFlightModalContent.slider__wrp,
			fareGroup__slide: DesktopFlightModalContent.fareGroup__slide,
			scroll_up: DesktopFlightModalContent.scroll_up
		},
		FlightInfoSegment: {
			card: DesktopFlightInfoSegment.card
		},
		Location: {
			time: DesktopFlightLocation.time,
			time_iata: DesktopFlightLocation.time_iata,
			city: DesktopFlightLocation.city,
			date: DesktopFlightLocation.date,
			date_icon: DesktopFlightLocation.date_icon,
			airport: DesktopFlightLocation.airport,
			terminal: DesktopFlightLocation.terminal,
			terminal_iata: DesktopFlightLocation.terminal_iata,
			isMobile: DesktopFlightLocation.isMobile
		},
		SelectedFareGroup: {
			button: DesktopFlightSelectedFareGroup.button
		},
		DesktopFlightModalHeader: {
			title: DesktopFlightModalHeader.title
		},
		DesktopFlightPopup: {
			paper: DesktopFlightPopup.paper
		}
	},
	FlightCard: {
		FlightCard: {
			airline: FlightCard.airline,
			airline__number: FlightCard.airline__number,
			airline__name: FlightCard.airline__name,
			aircraft__name_active: FlightCard.aircraft__name_active,
			flight: FlightCard.flight
		}
	},
	TransferInfo: {
		TransferInfo: {
			transfer: TransferInfo.transfer,
			transfer__layover: TransferInfo.transfer__layover
		}
	},
	CompareFares: {
		CompareFares: {
			compareFares: CompareFares.compareFares
		},
		Content: {
			groupTitle: CompareFares.groupTitle,
			tableRow: CompareFares.tableRow
		},
		Fare: {
			fareHeadingItem: CompareFares.fareHeadingItem,
			fareHeadingItem__title: CompareFares.fareHeadingItem__title,
			fareHeadingItem_isKey: CompareFares.fareHeadingItem_isKey,
			selectedFare: CompareFares.selectedFare
		},
		Header: {
			slider_withoutImages: CompareFares.slider_withoutImages
		}
	},
	FareConditions: {
		FareConditions: {
			paperRoot: Results.fareConditions__paperRoot
		}
	},
	FareLock: {
		FareLock: {
			root: FareLock.root
		}
	},
	Toolbar: {
		Toolbar: {
			toolbar: Toolbar.toolbar,
			button: Toolbar.button,
			backButton: Toolbar.backButton,
			price: Toolbar.price,
			actions: Results.toolbar_actions
		}
	},
	MobileSegmentInfo: {
		MobileSegmentFlat: {
			image: MobileSegmentInfo.image
		}
	},
	MobileFlight: {
		FlightStyles: {
			price: MobileFlight.price
		}
	},
	SeatMap: {
		AirplaneStyles: {
			airplane: Airplane.airplane,
			airplane__name: Airplane.airplane__name,
			details: Airplane.details,
			seatsDetails: Airplane.seatsDetails,
			seatsDetails_icon: Airplane.seatsDetails_icon
		},
		AirplaneInfoStyles: {
			sunInfo: Airplane.sunInfo
		},
		Passenger: {
			avatar: Passenger.avatar,
			item: Passenger.item,
			item_active: Passenger.item_active,
			passengerName: Passenger.passengerName,
			money: Passenger.money,
			clear: Passenger.clear,
			item_recommend: Passenger.item_recommend
		},
		PassengersStyles: {
			recommend: SeatMapPassengers.recommend,
			recommend__wrapper: SeatMapPassengers.recommend__wrapper,
			recommend__label: SeatMapPassengers.recommend__label,
			recommend__price: SeatMapPassengers.recommend__price,
			recommend__icon: SeatMapPassengers.recommend__icon,
			passengers__button: SeatMapPassengers.passengers__button,
			together: SeatMapPassengers.together,
			slider: SeatMapPassengers.slider
		},
		SeatMapDisclaimerStyles: {
			disclaimer: SeatMap.disclaimer
		},
		Controls: {
			button: SeatMap.controls_button,
			back: SeatMap.controls__back
		},
		SeatMapStyles: {
			row__serviceHeader__wrapper: SeatMap.row__serviceHeader__wrapper,
			row__serviceHeader_comfort: SeatMap.row__serviceHeader_comfort,
			row__serviceHeader: SeatMap.row__serviceHeader,
			row__PartWrpWithTechFacilities: SeatMap.row__PartWrpWithTechFacilities
		},
		SeatStyles: {
			seat: SeatMap.seat,
			seat_occupied: SeatMap.seat_occupied,
			seat_confirmed: SeatMap.seat_confirmed,
			seat_recommendCurrent: SeatMap.seat_recommendCurrent,
			seat_recommend: SeatMap.seat_recommend,
			number: SeatMap.seat_number,
			seat_business: SeatMap.seat_business,
			seat_preferred: SeatMap.seat_preferred,
			seat_unavailable: SeatMap.seat_unavailable,
			seat_unexistent: SeatMap.seat_unexistent,
			extendedIcon: SeatMap.extendedIcon
		},
		SeatChoose: {
			content: SeatMap.seatChoose__content,
			preferred: SeatMap.seatChoose__preferred,
			business: SeatMap.seatChoose__business,
			seat: SeatMap.seatChoose__seat,
			extendedIcon: SeatMap.seatChoose__extendedIcon
		},
		SeatsInfoStyles: {
			price__wrapper: SeatsInfo.price__wrapper,
			image: SeatsInfo.image,
			price: SeatsInfo.price,
			feature: SeatsInfo.feature,
			description: SeatsInfo.description,
			features: SeatsInfo.features,
			seat: SeatsInfo.seat,
			seat_free: SeatsInfo.seat_free,
			header: SeatsInfo.header,
			title: SeatsInfo.title,
			seat__info: SeatsInfo.seat__info,
			note: SeatsInfo.note,
			freeSeat__container: SeatsInfo.freeSeat__container,
			freeSeat__seat: SeatsInfo.freeSeat__seat,
			seat_preferred: SeatsInfo.seat_preferred,
			info: SeatsInfo.info
		},
		SeatTooltipStyles: {
			popper: SeatMap.tooltip_popper,
			tooltip: SeatMap.tooltip,
			info: SeatMap.tooltip_info,
			tooltip_withInfo: SeatMap.tooltip_withInfo,
			tooltip_recommend: SeatMap.tooltip_recommend
		},
		DoubleSeat: {
			container: SeatMap.doubleSeat_container
		},
		SureModal: {
			button: SeatMap.sureModal_button
		},
		ComponentStyles: {
			seatsInfo_content: SeatsInfo.info
		}
	},
	Baggage: {
		Baggage: {
			name: Baggage.baggage_name,
			size: Baggage.baggage_icon_size
		},
		BaggageIcon: {
			root: Baggage.baggage_icon_root,
			wrapper: Baggage.baggage_icon_wrapper,
			size: Baggage.baggage_icon_size,
			value: Baggage.baggage_icon_value,
			measurement: Baggage.baggage_icon_measurement
		}
	},
	BaggageTotalPriceBlock: {
		BaggageTotalPriceBlock: {
			root: Baggage.total_price_root,
			price: Baggage.total_price_price
		}
	},
	BaggageCard: {
		BaggageCard: {
			wrapper: Baggage.card_block_wrapper,
			header: Baggage.card_header,
			selected: Baggage.card_selected,
			icon: Baggage.card_icon,
			info: Baggage.card_info,
			title: Baggage.card_title,
			description: Baggage.card_description,
			button: Shared.Button.button_small,
			price: Baggage.control_price,
			footer: Baggage.total_price_root
		}
	},
	BaggagePage: {
		BaggagePage: {
			additionalBaggage: Baggage.block_wrapper,
			baggage: Baggage.mobile_body,
			items: Baggage.mobile_items,
			additional: Baggage.mobile_additional,
			newBaggage: Baggage.mobile_newBaggage,
			equipment_baggage: Baggage.equipment_baggage,
			overweight_baggage: Baggage.overweight_baggage,
			extra_baggage: Baggage.extra_baggage,
			included_baggage: Baggage.included_baggage
		}
	},
	IncludedBaggage: {
		IncludedBaggage: {
			root: Baggage.block_wrapper,
			header: Baggage.card_title,
			included_block: Baggage.included_block,
			upgrade_block: Baggage.included_upgrade_block,
			footer: Baggage.included_footer
		}
	},
	AdditionalBaggage: {
		AdditionalBaggage: {
			root: Baggage.block_wrapper,
			header: Baggage.card_title,
			body: Baggage.card_body,
			footer: Baggage.additional_footer,
			promo_message: Baggage.promo_message
		}
	},
	OverweightBaggage: {
		OverweightBaggage: {
			flights: Baggage.overweight_flights,
			flight: Baggage.overweight_flight,
			flight_icon: Baggage.overweight_icon,
			flight_count: Baggage.overweight_flight_count,
			flight_info: Baggage.overweight_flight_info,
			flight_direction: Baggage.overweight_flight_direction
		}
	},
	SpecialEquipment: {
		SpecialEquipment: {
			flights: Baggage.overweight_flights,
			flight: Baggage.overweight_flight,
			flight_icon: Baggage.overweight_icon,
			flight_count: Baggage.overweight_flight_count,
			flight_info: Baggage.overweight_flight_info,
			flight_direction: Baggage.overweight_flight_direction
		}
	},
	BaggageList: {
		BaggageList: {
			item: Baggage.baggage_list__item,
			add: Baggage.baggage_list_add,
			root: Baggage.baggageList__root
		},
		BaggageCount: {
			root: Baggage.baggage_count_root
		},
		BaggageDirection: {
			root: Baggage.baggage_direction_root
		}
	},
	UpgradeBaggageDialog: {
		MobileBaggageSelector: {
			container: Baggage.mobile_baggage_selector,
			footer: Baggage.mobile_baggage_selector_footer,
			price: Baggage.mobile_baggage_selector_price,
			description: Baggage.mobile_baggage_selector_description,
			selector: Baggage.mobile_baggage_selector,
			selected: Baggage.mobile_baggage_selector_selected,
			icon: Baggage.mobile_baggage_selector_icon
		},
		UpgradeBaggageDialog: {
			modal__root: Modal.modal__root,
			root: Modal.content,
			body: UpgradeBaggageDialog.body,
			modalHeader: Modal.header,
			close: cn(Shared.CloseIcon.popup_position, Shared.CloseIcon.popup_wrapper)
		},
		BaggageSegment: {
			root: UpgradeBaggageDialog.segment_root,
			name: UpgradeBaggageDialog.segment_name,
			price: cn(UpgradeBaggageDialog.segment_price, Baggage.segment_price),
			name_withPrices: UpgradeBaggageDialog.segment_name_withPrices
		},
		BaggagePassenger: {
			root: PassengerCounter.root,
			row: PassengerCounter.row,
			name_wrapper: PassengerCounter.name_wrapper,
			counter_wrapper: cn(PassengerCounter.counter_wrapper, Baggage.counter_wrapper),
			number: cn(PassengerCounter.number, PassengerCounter.number_offset),
			name: PassengerCounter.name,
			checkbox_wrapper: Shared.Checkbox.checkbox_wrapper,
			checkbox_root: Shared.Checkbox.checkbox_root,
			checkbox_rootChecked: Shared.Checkbox.checkbox_rootChecked
		},
		BaggageFooter: {
			root: cn(Modal.footer_root, UpgradeBaggageDialog.footer_root),
			row: Modal.footer_row,
			buttons_row: Modal.footer_buttons_row,
			confirm_btn: Modal.footer_confirm_btn,
			cancel_btn: Modal.footer_cancel_btn,
			price_block: Shared.ModalPriceBlock.price_block,
			price_wrapper: Shared.ModalPriceBlock.price_wrapper,
			price_block__delimiter: Shared.ModalPriceBlock.price_block__delimiter,
			clear: cn(Shared.ModalPriceBlock.button_clear, Shared.Button.link_button)
		},
		BaggageDialogHeader: {
			baggage_wrapper: UpgradeBaggageDialog.baggage_wrapper,
			row: UpgradeBaggageDialog.header_row,
			price_label: UpgradeBaggageDialog.header_price_label,
			perFlight: UpgradeBaggageDialog.header_perFlight,
			price_wrapper: Baggage.baggage_icon_price_wrapper,
			description: Baggage.header_description,
			category_title: Baggage.category_title,
			category_description: Baggage.category_description,
			categories: Baggage.headerEquipment_categories
		},
		HeaderEquipmentItem: {
			wrapper: Baggage.headerEquipment_wrapper,
			active: Baggage.headerEquipment_active
		}
	},
	AdditionalServiceWrapper: {
		AdditionalServiceWrapper: {
			total: AdditionalServiceWrapper.total,
			total__clear: AdditionalServiceWrapper.total__clear
		}
	},
	AdditionalServiceBanner: {
		AdditionalServiceBannerStyles: {
			baggageBanner: Baggage.baggage__banner,
			text: Baggage.baggage__banner_text,
			image: Baggage.baggage__banner_image,
			disclaimer: Baggage.baggage__banner_disclaimer,
			disclaimer__icon: Baggage.baggage__banner_disclaimer__icon
		}
	},
	MealService: {
		List: {
			wrapper: Shared.TabsList.list__wrapper,
			item: Shared.TabsList.list__item,
			item_selected: Shared.TabsList.list__itemSelected,
			item__icon: Shared.TabsList.list__itemIcon
		},
		CategoriesStyles: {
			mobile__header: Shared.TabsList.categories__mobileHeader
		},
		ServiceWrapper: {
			segmentTabs_segments: MealService.serviceWrapper__segmentTabsMeal,
			meal: MealService.serviceWrapper__meal
		}
	},
	Meal: {
		Meal: {
			meal: Meal.meal,
			header: Meal.meal_header,
			image: Meal.meal_image,
			title: Meal.meal_title,
			name: Meal.meal_name,
			footer: Meal.meal_footer,
			footer__icons: Meal.meal_footer_icons,
			popup__close: Shared.CloseIcon.popup_position,
			price: Meal.meal_price,
			meal_fullSize: Meal.meal_fullSize,
			count: Meal.meal_count,
			popup: Meal.popup_wrapper
		},
		Details: {
			wrapper: cn(Meal.popup_wrapper, Modal.wrapper),
			selector: cn(Meal.selector, Modal.content),
			footer: cn(Modal.footer_row, Modal.mobile_row),
			footer__price: Shared.ModalPriceBlock.price_block,
			button_empty: cn(Modal.footer_confirm_btn, Modal.button_empty),
			addForAll: Shared.Button.link_button,
			clear: Shared.Button.link_button,
			counters: Meal.counters,
			counter: PassengerCounter.root,
			total: cn(Shared.ModalPriceBlock.price_wrapper, Meal.total),
			totalText: Shared.ModalPriceBlock.price_block,
			passenger: PassengerCounter.name_wrapper,
			passenger__index: PassengerCounter.number,
			content: Meal.content,
			name: Meal.name,
			row: Meal.content_row,
			trigger: Meal.content_row_trigger,
			trigger__icon: Meal.content_trigger__icon,
			priceWrapper: Meal.content_row_priceWrapper,
			description__row: Meal.description_row,
			image: Meal.popup_image,
			totalPrice: Meal.totalPrice
		}
	},
	AircraftPopup: {
		AircraftPopup: {
			close: cn(Shared.CloseIcon.popup_position, Shared.CloseIcon.popup_wrapper)
		}
	},
	Modal: {
		Modal: {
			closeIcon: cn(Shared.CloseIcon.popup_wrapper, Shared.CloseIcon.popup_position),
			modal: Modal.wrapper
		}
	},
	DesktopSummaryFlight: {
		SummaryFlight: {
			flight: DesktopSummaryFlight.flight
		}
	},
	Contacts: {
		ContactsStyles: {
			contacts: Contacts.contacts,
			header: Contacts.header,
			description__header: Contacts.description__header,
			description__text: Contacts.description__text,
			description__content: Contacts.description__content,
			checkbox__label: Contacts.checkbox__label,
			footer_login: Contacts.footer_login,
			footer__inner: Contacts.footer__inner,
			footer__text: Contacts.footer__text
		}
	},
	PassengerForm: {
		PassengerForm: {
			form: PassengerForm.form
		},
		Header: {
			header: PassengerFormHeader.header,
			filled: PassengerFormHeader.filled,
			number: PassengerFormHeader.number,
			passengerName: PassengerFormHeader.passengerName,
			payload: PassengerFormHeader.payload
		},
		Group: {
			container: cn(PassengerFormGroup.container, PassengerFormGroup.container_icon),
			identity: PassengerFormGroup.identity,
			documents: PassengerFormGroup.documents
		},
		LoyaltyGroup: {
			container_loyalty: PassengerFormGroup.loyalty,
			loyalty__desc: PassengerFormGroup.loyalty__desc
		},
		Disabilities: {
			container: cn(PassengerFormGroup.disabilities, PassengerFormGroup.container_icon),
			disabilities__text: PassengerFormGroup.disabilities__text,
			checkboxes: PassengerFormGroup.checkboxes
		}
	},
	Passenger: {
		PassengerSwitch: {
			element: PassengerSwitch.element,
			element_active: PassengerSwitch.element_active,
			element_error: PassengerSwitch.element_error,
			error: cn(PassengerSwitch.error, PassengerFormGroup.switch__error)
		},
		Select: {
			real_input: Input.real_input
		}
	},
	Input: {
		Input: {
			textField__root: Input.textField__root,
			real_input: Input.real_input,
			hint: Input.hint
		}
	},
	OrderCard: {
		OrderCard: {
			type_account: OrderCard.type_account,
			type_review: OrderCard.type_review,
			container: OrderCard.container,
			root: OrderCard.root,
			preview: OrderCard.preview,
			status: OrderCard.status,
			passengers: OrderCard.passengers,
			buttons: OrderCard.buttons,
			booking: OrderCard.booking
		},
		OrderPreview: {
			root: cn(OrderCard.orderPreview),
			overlay: OrderPreview.overlay,
			city: OrderPreview.city,
			main_city: OrderPreview.main_city,
			period: OrderPreview.period
		},
		OrderBooking: {
			type_account: OrderBooking.type_account,
			type_review: OrderBooking.type_review,
			root: OrderBooking.root,
			orderCode: OrderBooking.orderCode,
			download: OrderBooking.download,
			security_code: OrderBooking.security_code
		},
		OrderPassengers: {
			control: OrderCard.link,
			paper: OrderCard.paper
		},
		OrderTickets: {
			link: OrderCard.link
		},
		CommonItem: {
			root: OrderCommonItem.root,
			review: OrderCommonItem.review,
			payload: cn(OrderCard.payload),
			icon: OrderCommonItem.icon,
			account: OrderCommonItem.account,
			buttons: OrderCommonItem.buttons
		},
		OrderCardControls: {
			root: OrderCardControls.root,
			button: OrderCardControls.button,
			button_checkin: cn(OrderCardControls.button_checkin, OrderCard.button_checkin)
		},
		OrderStatus: {
			root: cn(OrderCard.orderStatus)
		},
		PaymentStatus: {
			root: cn(OrderCard.paymentStatus),
			icon: cn(OrderCard.paymentStatusIcon),
			account: OrderCard.type_account,
			payload: OrderCard.payload
		},
		DeleteOrderModal: {
			delete_order: DeleteOrderModal.delete_order,
			header: DeleteOrderModal.header,
			footer: DeleteOrderModal.footer,
			content: DeleteOrderModal.content,
			button__cancel: Shared.Button.action
		}
	},
	CheckoutAdditionalService: {
		CheckoutAdditionalService: {
			service: CheckoutAdditionalService.service,
			service_active: CheckoutAdditionalService.service_active,
			header: CheckoutAdditionalService.header,
			icon: CheckoutAdditionalService.icon,
			header__text: CheckoutAdditionalService.header__text,
			header__price: CheckoutAdditionalService.header__price,
			content: CheckoutAdditionalService.content,
			buttons: CheckoutAdditionalService.buttons,
			add: CheckoutAdditionalService.add
		},
		Transfer: {
			header: CheckoutAdditionalService.service_transfer
		},
		PriorityBoarding: {
			priorityBoardingModal: CheckoutAdditionalService.priorityBoardingModal,
			header: CheckoutAdditionalService.header_priority
		},
		InsuranceUpsale: {
			paper: CheckoutAdditionalService.insuranceUpsale_paper,
			content: CheckoutAdditionalService.insuranceUpsale_content,
			options: CheckoutAdditionalService.insuranceUpsale_options
		}
	},
	Checkout: {
		CheckoutStyles: {
			container: Checkout.container,
			gdsTotalPrice: Checkout.gdsTotalPrice,
			form: Checkout.form,
			checkoutServices: Checkout.checkoutServices,
			summary__header: Checkout.summary__header
		},
		PassengersStyles: {
			passengers: CheckoutPassengers.passengers
		},
		PassengersToolbar: {
			label: CheckoutPassengersToolbar.label
		},
		ThanksBanner: {
			wrapper: CheckoutThanksBanner.wrapper,
			title: CheckoutThanksBanner.title
		},
		CheckDataModal: {
			paper: CheckDataModal.paper,
			contentWrapper: CheckDataModal.contentWrapper,
			footer: CheckDataModal.footer,
			header: CheckDataModal.header,
			checkData__title: CheckDataModal.title
		}
	},
	ModalConfirm: {
		ModalConfirm: {
			header: ModalConfirm.header,
			buttons: ModalConfirm.buttons,
			content: ModalConfirm.content,
			footer: ModalConfirm.footer,
			cancelButton: ModalConfirm.cancelButton,
			confirmButton: ModalConfirm.confirmButton
		}
	},
	BaseComponents: {
		ModalX: {
			closeButton: ModalX.closeButton
		},
		Button: {
			optionAction: cn(Shared.Button.action__colorsOnly)
		}
	},
	Autocomplete: {
		Autocomplete: {
			option: Autocomplete.option
		}
	},
	Cart: {
		Toolbar: {
			money: CartToolbar.money
		}
	},
	ServiceSummary: {
		ServiceSummary: {
			header__title: ServiceSummary.header__title,
			header__price: ServiceSummary.header__price
		},
		ServiceSummaryOption: {
			header__title: cn(ServiceSummary.header__title),
			option__name: ServiceSummaryOption.option__name,
			option__price: ServiceSummaryOption.option__price
		}
	},
	InsurancePopup: {
		InsurancePopup: {
			header: InsurancePopup.header,
			content: InsurancePopup.content
		},
		InsuranceCard: {
			wrapper: InsurancePopup.insuranceCard_wrapper,
			active: InsurancePopup.insuranceCard_active,
			header: InsurancePopup.insuranceCard_header
		}
	},
	AddBooking: {
		AddBooking: {
			wrapper: AddBooking.wrapper
		}
	},
	WxPagination: {
		WxPagination: {
			ul: WxPagination.ul,
			button: WxPagination.button
		}
	},
	LoyaltyInfo: {
		LoyaltyInfo: {
			content: LoyaltyInfo.content
		},
		LoyaltyInfoV2: {
			Card: {
				wrapper: LoyaltyInfoCard.wrapper,
				overlay: LoyaltyInfoCard.overlay,
				compliment: LoyaltyInfoCard.compliment,
				appreciation: LoyaltyInfoCard.appreciation,
				gratitude: LoyaltyInfoCard.gratitude,
				header: LoyaltyInfoCard.header,
				info: LoyaltyInfoCard.info,
				number: LoyaltyInfoCard.number,
				levelImage: LoyaltyInfoCard.levelImage
			}
		},
		Card: {
			number: LoyaltyInfoCard.number,
			wrapper: LoyaltyInfoCard.wrapper,
			info: LoyaltyInfoCard.info,
			header: LoyaltyInfoCard.header,
			compliment: LoyaltyInfoCard.compliment,
			appreciation: LoyaltyInfoCard.appreciation,
			gratitude: LoyaltyInfoCard.gratitude
		},
		FfpInfo: {
			miles: FfpInfo.miles,
			progress_status: FfpInfo.progress_status,
			progress_bg: FfpInfo.progress_bg,
			progress_color: FfpInfo.progress_color,
			text: FfpInfo.text,
			links: FfpInfo.links,
			progress_fares: FfpInfo.progress_fares,
			progress_text: FfpInfo.progress_text
		}
	},
	MilesHistory: {
		MilesHistory: {
			listHeader_item: MilesHistory.listHeader_item,
			listItem_col: MilesHistory.listItem_col
		}
	},
	Traveller: {
		Traveller: {
			popup__header: Traveller.popup__header
		}
	},
	AccountModule: {
		Account: {
			wrapper: AccountModule.wrapper
		}
	},
	Checkin: {
		Checkin: {
			extras: Checkin.extras,
			wrapper: Checkin.wrapper
		},
		Inital: {
			wrapper: CheckinInital.wrapper,
			form: CheckinInital.form,
			hint: CheckinInital.hint
		},
		Passengers: {
			segments: CheckinPassengers.segments,
			passengers: CheckinPassengers.passengers
		},
		Order: {
			stepBar: CheckinInital.stepBar,
			mobileStepBar: CheckinInital.mobileStepBar
		}
	},
	ResendTicketsForm: {
		ResendTicketsForm: {
			input: ResendTicketsForm.input,
			input_underline: ResendTicketsForm.input_underline,
			input_focused: ResendTicketsForm.input_focused
		}
	},
	StatusMessage: {
		StatusMessage: {
			statusMessage: StatusMessage.statusMessage,
			statusMessage__text: StatusMessage.statusMessage__text,
			statusMessage__title: StatusMessage.statusMessage__title
		}
	},
	MobileSegment: {
		MobileSegment: {
			wrapper: MobileSegment.wrapper,
			wrapper_business: MobileSegment.wrapper_business,
			planeIcon: MobileSegment.planeIcon,
			flightInfo: MobileSegment.flightInfo,
			flightInfo__cities: MobileSegment.flightInfo__cities,
			flightInfo__time: MobileSegment.flightInfo__time,
			fareGroup: MobileSegment.fareGroup,
			flightNumber: MobileSegment.flightNumber,
			fareGroup__img: MobileSegment.fareGroup__img,
			arrivalInfo: MobileSegment.arrivalInfo,
			arrivalInfo__title: MobileSegment.arrivalInfo__title,
			arrivalInfo__item: MobileSegment.arrivalInfo__item,
			arrivalInfo__place: MobileSegment.arrivalInfo__place,
			info: MobileSegment.info
		}
	},
	MobileStepbar: {
		StepbarHeader: {
			header: MobileSegment.stepbarHeader__header
		},
		StepbarServiceSummary: {
			container: MobileSegment.stepbarServiceSummary__container
		}
	},
	Segment: {
		SegmentCommon: {
			wrapper: SegmentCommon.wrapper,
			wrapper_business: SegmentCommon.wrapper_business,
			cities: SegmentCommon.cities,
			city__airport: SegmentCommon.city__airport,
			city__info: SegmentCommon.city__info,
			city__time: SegmentCommon.city__time,
			plane__icon: SegmentCommon.plane__icon,
			flightInfo: SegmentCommon.flightInfo,
			flightInfo__item: SegmentCommon.flightInfo__item,
			flightInfo__title: SegmentCommon.flightInfo__title,
			flightInfo__value: SegmentCommon.flightInfo__value,
			footer: SegmentCommon.footer,
			footer__item: SegmentCommon.footer__item
		}
	},
	RetrieveBooking: {
		RetrieveBooking: {
			form__row: RetrieveBooking.form__row,
			title: RetrieveBooking.title,
			form: RetrieveBooking.form
		}
	},
	SelectedPassenger: {
		SelectedPassenger: {
			wrapper: SelectedPassenger.wrapper,
			passengerInfo: SelectedPassenger.passengerInfo,
			passengerInfo__item: SelectedPassenger.passengerInfo__item,
			rightSide: SelectedPassenger.rightSide,
			passengerInfo__field: SelectedPassenger.passengerInfo__field,
			loyalty__link: SelectedPassenger.loyalty__link,
			passenger__icon: SelectedPassenger.passenger__icon
		}
	},
	RegisteredPassenger: {
		RegisteredPassenger: {
			wrapper: RegisteredPassenger.wrapper,
			header: RegisteredPassenger.header,
			passenger: RegisteredPassenger.passenger,
			seats__icon: RegisteredPassenger.seats__icon,
			actions__buttons: RegisteredPassenger.actions__buttons,
			downloadButton: RegisteredPassenger.downloadButton,
			downloadIcon: RegisteredPassenger.downloadIcon,
			footerActions: RegisteredPassenger.footerActions,
			footerActions__cancel: RegisteredPassenger.footerActions__cancel,
			appleWallet: RegisteredPassenger.appleWallet
		},
		Service: {
			service: Service.service,
			service__icon: Service.service__icon,
			service__info: Service.service__info,
			service__name: Service.service__name
		}
	},
	Exchange: {
		Inner: {
			header__text: Exchange.header__text,
			closeIcon: Exchange.closeIcon,
			header: Exchange.header
		},
		Chip: {
			chip: Exchange.chip,
			close: Exchange.chip_close
		},
		Choice: {
			label: Exchange.label,
			label_selected: Exchange.label_selected,
			container: Exchange.choice_container
		},
		CommonSelect: {
			buttons: Exchange.commonSelect_buttons,
			header: Exchange.commonSelect_header,
			button: Shared.Button.action
		},
		SearchFlights: {
			leg: Exchange.searchFlights_leg,
			header: Exchange.searchFlights_header,
			route: Exchange.searchFlights_route,
			header__cities: Exchange.searchFlights_header__cities
		},
		Sort: {
			sortings: Exchange.searchFlights_sortings,
			title: Exchange.searchFlights_sortings__title,
			currentSorting: Exchange.searchFlights_currentSorting
		},
		Calendar: {
			calendar: Exchange.searchFlights_calendar,
			day_highlight: SearchFormDatepickerDay.day_highlight,
			day_notAvailable: SearchFormDatepickerDay.day_notAvailable,
			day_inPeriod: SearchFormDatepickerDay.day_inPeriod,
			monthsWrapper__wrapper: Exchange.monthsWrapper__wrapper,
			month_month: Exchange.month_month,
			datepicker__modal: Exchange.datepicker__modal
		},
		Disclaimer: {
			wrapper: Exchange.disclaimer_wrapper
		},
		SelectedFlights: {
			header__name: Exchange.selectedFlights__header_name,
			change: Exchange.selectedFlights__change,
			price: Exchange.selectedFlights__price,
			charge: Exchange.selectedFlights__charge,
			charge__money: Exchange.selectedFlights__charge__money,
			total__money: Exchange.selectedFlights__total__money,
			total: Exchange.selectedFlights__total,
			money: Exchange.selectedFlights__money
		},
		Selections: {
			wrapper: Exchange.selections_wrapper
		},
		CreateRequest: {
			submit: Shared.Button.action__colorsOnly,
			controls: Exchange.createRequest_controls
		},
		RequestControls: {
			container: Exchange.requestControls_container,
			button: Shared.Button.action__colorsOnly
		},
		RequestForm: {
			order: Exchange.order,
			status: Exchange.status,
			status_error: Exchange.status_reject,
			status_reject: Exchange.status_reject,
			status_awaitingPayment: Exchange.status_awaitingPayment
		}
	},
	Refund: {
		Breadcrumbs: {
			breadcrumb: Refund.breadcrumb
		},
		Wrapper: {
			title: Refund.title,
			header: Refund.header,
			header_wrapper: Refund.header_wrapper
		},
		StepTitle: {
			icon: Refund.stepTitle_icon
		},
		OrderRefundStatus: {
			title: Refund.orderRefundStatus_title,
			right: Refund.orderRefundStatus_right,
			status: Refund.orderRefundStatus_status,
			processing: Refund.orderRefundStatus_processing
		},
		StepsButtons: {
			wrapper: Refund.stepsButtons_wrapper,
			button: Shared.Button.action,
			backButton: Refund.stepsButtons_backButton
		},
		Passenger: {
			active: Refund.passenger_active,
			passenger: Refund.passenger
		},
		MobileStep: {
			header: Refund.mobileStep_header
		},
		Ticket: {
			status: Refund.ticket_status,
			confirm: Refund.ticket_confirm,
			reject: Refund.ticket_reject,
			price: Refund.ticket_price
		},
		Status: {
			waiting: Refund.status_waiting
		},
		Refund: {
			buttons: Refund.buttons,
			stepTitle: Refund.stepTitle
		},
		RefundPaper: {
			paper: Refund.paper
		},
		RequestForm: {
			notes: Refund.requestForm_notes,
			wrapper: Refund.requestForm,
			agree: Refund.requestForm_agree
		}
	},
	PromoLoader: {
		PromoLoader: {
			promo__icon: PromoLoader.promo__icon
		}
	},
	VipServiceSelect: {
		VipServiceSelect: {
			confirm: VipServiceSelect.confirm,
			cancel: VipServiceSelect.cancel
		}
	},
	DocumentForm: {
		DocumentForm: {
			form: DocumentForm.form
		}
	},
	Loyalty: {
		LoyaltyConnect: {
			login__modal_content: Loyalty.login__modal_content,
			header: Loyalty.header,
			loyaltyConnect: Loyalty.loyaltyConnect,
			group: Loyalty.group,
			group__field: Loyalty.group__field,
			group__field_switch: Loyalty.group__field_switch,
			buttons__wrapper: Loyalty.buttons__wrapper
		},
		ForgotPassword: {
			header: Loyalty.forgotPassword__header
		}
	},
	Transfer: {
		TransferSelector: {
			serviceCard: Transfer.serviceCard,
			buttons: Transfer.buttons,
			description: Transfer.description,
			active: Transfer.active,
			header: Transfer.header,
			headerText: Transfer.headerText,
			headerPrice: Transfer.headerPrice
		},
		TransferSelectorModal: {
			confirm: Transfer.confirm,
			footer: Transfer.footer,
			footerControls: Transfer.footerControls
		}
	},
	LoginPage: {
		SubmitButton: {
			root: Shared.Button.action
		},
		LoginForm: {
			social_wrapper: AccountModule.loginForm__social_wrapper,
			social_title: AccountModule.loginForm__social_title
		}
	},
	InsurancePage: {
		InsurancePage: {
			wrapper: InsurancePage.page__wrapper,
			content: InsurancePage.page__content,
			header: InsurancePage.page__header,
			title: InsurancePage.page__title,
			subheader: InsurancePage.page__subheader,
			insurancesList: InsurancePage.page__insurancesList
		},
		InsuranceProduct: {
			title: InsurancePage.product__title,
			popular: InsurancePage.product__popular,
			content: InsurancePage.product__content,
			description: InsurancePage.product__description,
			options: InsurancePage.product__options,
			moreInfo: InsurancePage.product__moreInfo,
			linksWrapper: InsurancePage.product__linksWrapper,
			selectButton: InsurancePage.product__selectButton
		},
		InsuranceUpsaleModal: {
			button: InsurancePage.upsaleModal__button,
			root: InsurancePage.upsaleModal__root,
			header: InsurancePage.upsaleModal__header,
			listWrapper: InsurancePage.upsaleModal__listWrapper
		},
		InsurancePrice: {
			price: InsurancePage.price__price,
			content: InsurancePage.price__content,
			bold: InsurancePage.price_bold,
			regular: InsurancePage.price_regular,
			light: InsurancePage.price_light,
			forAllPassengers: InsurancePage.price_forAllPassengers
		},
		SelectForm: {
			root: InsurancePage.selectForm__root,
			label: InsurancePage.selectForm__label,
			checked: InsurancePage.selectForm__checked,
			radio: InsurancePage.selectForm__radio,
			price: InsurancePage.selectForm__price,
			priceContent: InsurancePage.selectForm__priceContent
		},
		Banner: {
			icons: InsurancePage.banner__icons,
			popularBadge: InsurancePage.banner__popularBadge
		},
		OptionsList: {
			list: InsurancePage.optionsList__list
		}
	},
	Features: {
		StartCheckIn: {
			AcceptCheckinRules: {
				rules__button: cn(Shared.Button.action, Shared.Button.mobile_radius0),
				rules: CheckinRules.rules,
				rules__text: CheckinRules.rules__text
			}
		}
	},
	Entities: {
		Fare: {
			TaxesTooltip: {
				root: Fare.taxesTooltip__root
			}
		}
	}
};

export default theme;
